export const PARTNER_STATUS_APPROVED = "Approved";
export const PARTNER_STATUS_PENDING = "Pending";
export const PARTNER_STATUS_DECLINED = "Declined";
export const PARTNER_STATUS_ACCEPTED = "Accepted";

/* Update Partner Status */
export const REQUEST_UPDATE_PARTNER = "REQUEST_UPDATE_PARTNER";
export const RECEIVE_UPDATE_PARTNER = "RECEIVE_UPDATE_PARTNER";
export const PARTNER_UPDATE_ERROR = "PARTNER_UPDATE_ERROR";
